import { ReactNode } from 'react';

import cursorIcon from '@atom/components/common/svgIcons/mapCursor.svg';
import cursorIconSelected from '@atom/components/common/svgIcons/mapCursorSelected.svg';
import grabIcon from '@atom/components/common/svgIcons/mapGrab.svg';
import grabIconSelected from '@atom/components/common/svgIcons/mapGrabSelected.svg';
import polygonIcon from '@atom/components/common/svgIcons/polygonDraw.svg';
import polygonIconSelected from '@atom/components/common/svgIcons/polygonDrawSelected.svg';
import radiusIcon from '@atom/components/common/svgIcons/radiusDraw.svg';
import radiusIconSelected from '@atom/components/common/svgIcons/radiusDrawSelected.svg';
import { type IconComponent, StraightenIcon } from '@atom/mui/icons';

import MapControl from '../toolbar/MapControl';

import { MapDrawingSlice } from './drawingTypes';
import { Interaction } from './geometry';

import classes from './drawing.module.css';

const MODES: ReadonlyArray<Interaction> = [
  'select',
  'grab',
  'circle',
  'polygon',
  'linestring',
];

const SVG_ICONS: Partial<
  Record<Interaction, { default: string; selected: string }>
> = {
  select: { default: cursorIcon, selected: cursorIconSelected },
  grab: { default: grabIcon, selected: grabIconSelected },
  circle: { default: radiusIcon, selected: radiusIconSelected },
  polygon: { default: polygonIcon, selected: polygonIconSelected },
};

const MODE_TOOLTIPS: Record<Interaction, string> = {
  select: 'Select',
  grab: 'Grab',
  point: 'Place a point',
  circle: 'Draw a radius',
  polygon: 'Draw a polygon',
  linestring: 'Measure distance',
};

type DrawingToolbarProps = {
  drawing: MapDrawingSlice;
};

const DrawingToolbar = ({ drawing }: DrawingToolbarProps) => {
  const { mode, onModeChange } = drawing;

  return (
    <div className={classes.drawingToolbar} data-cy="drawingToolbar">
      {MODES.map(interactionMode => {
        const active = mode === interactionMode;
        const svg = SVG_ICONS[interactionMode];
        const icon: IconComponent | ReactNode = svg ? (
          <img
            src={active ? svg.selected : svg.default}
            alt={MODE_TOOLTIPS[interactionMode]}
          />
        ) : interactionMode === 'linestring' ? (
          StraightenIcon
        ) : null;

        return (
          <div key={interactionMode} className={classes.toolbarButton}>
            <MapControl
              icon={icon}
              active={active}
              tooltip={MODE_TOOLTIPS[interactionMode]}
              onClick={() => onModeChange(interactionMode)}
              dataCy={`drawingToolbar-${interactionMode}`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default DrawingToolbar;
